import { Navigate, Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import PasswordModal from "@/components/PasswordModal";

function ProtectedRoutes() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const savedAuth = sessionStorage.getItem("dashboardAuth");
    if (savedAuth === "true") {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  if (isLoading) return null;

  if (!isAuthenticated) {
    return <PasswordModal onSuccess={() => {
      sessionStorage.setItem("dashboardAuth", "true");
      setIsAuthenticated(true);
    }} />;
  }

  return <Outlet />;
}

export default ProtectedRoutes;